<template>
  <Teleport to="body">
    <div v-if="rendered">
      <div ref="modal"
        class="modal fade"
        v-bind:class="{ show: shown }"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        style="display: block;"
        v-on:mousedown.self="hide">
        <div class="modal-dialog">
          <div class="modal-content" role="document">
            <header class="modal-header">
              <h5 class="modal-title"></h5>
              <button type="button" class="close" aria-label="Close" v-on:click="hide">×</button>
            </header>
            <div class="modal-body">
              <slot></slot>
            </div>
            <footer class="modal-footer">
              <button type="button" class="btn btn-secondary" v-on:click="hide">{{cancelTitle}}</button>
              <button type="button" class="btn btn-primary" v-on:click="ok">{{okTitle}}</button>
            </footer>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade" v-bind:class="{ show: shown }"></div>
    </div>
  </Teleport>
</template>

<script>
// Remplace le <b-modal> de bootstrap-vue 2 utilisé par le site : v-model, boutons OK / Annuler,
// fermeture par la croix, Échap ou un clic à côté, apparition en fondu.
const TRANSITION_MS = 300;

export default {
  name: 'BsModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    okTitle: {
      type: String,
      default: 'OK',
    },
    cancelTitle: {
      type: String,
      default: 'Cancel',
    },
  },
  emits: ['update:modelValue', 'ok'],
  data() {
    return {
      rendered: false,
      shown: false,
    };
  },
  watch: {
    modelValue(value) {
      if (value) {
        this.open();
      } else {
        this.close();
      }
    },
  },
  mounted() {
    if (this.modelValue) {
      this.open();
    }
  },
  beforeUnmount() {
    clearTimeout(this.timeout);
    this.unlockBody();
  },
  methods: {
    async open() {
      clearTimeout(this.timeout);
      this.rendered = true;
      this.lockBody();
      document.addEventListener('keydown', this.keydown);
      await this.$nextTick();
      // état initial affiché avant d'ajouter .show, pour que le fondu ait lieu
      this.$refs.modal.getBoundingClientRect();
      this.$refs.modal.focus();
      this.shown = true;
    },
    close() {
      this.shown = false;
      document.removeEventListener('keydown', this.keydown);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.rendered = false;
        this.unlockBody();
      }, TRANSITION_MS);
    },
    hide() {
      this.$emit('update:modelValue', false);
    },
    ok() {
      this.$emit('ok');
      this.hide();
    },
    keydown(event) {
      if (event.key === 'Escape') {
        this.hide();
      }
    },
    lockBody() {
      if (this.bodyLocked) {
        return;
      }
      this.bodyLocked = true;
      const scrollbar = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (scrollbar > 0) {
        document.body.style.paddingRight = `${scrollbar}px`;
      }
    },
    unlockBody() {
      if (!this.bodyLocked) {
        return;
      }
      this.bodyLocked = false;
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.removeEventListener('keydown', this.keydown);
    },
  },
};
</script>
